export default import.meta.ROLLDOWN_FILE_URL_Wn5Ul9bDxsRroZeP87_N6A